<template>
  <div>
    <div class="language-dropdown dropdown">
      <a class="nav-link dropdown-toggle"
         id="dropdown-language"
         data-toggle="dropdown"
         aria-haspopup="true"
         aria-expanded="false">
        <span>
            <flag :iso="currentLanguage.flag" v-bind:squared=false></flag>
                      {{currentLanguage.language_name}}
          </span> </a>
      <div class="dropdown-menu" aria-labelledby="dropdown-language">
        <a v-for="(entry, index) in availableLanguages"
           :key="index"
           @click="changeLocale(entry.language)"
           class="dropdown-item">
          <span>
            <flag :iso="entry.flag" v-bind:squared=false></flag>
                      {{entry.language_name}}
          </span> </a>
      </div>
    </div>
  </div>
</template>
<script>
  import {UserService} from "@/services";

  window.$ = window.jQuery = require('jquery');
  require('bootstrap');
  require('bootstrap-select')

  export default {
    name: 'locale-switch',
    computed: {
      availableLanguages: function () {
        return this.$store.getters['Localization/languages'];
      },
      currentLanguage: function () {
        var locale = this.$i18n.locale;
        return this.availableLanguages.filter(function (item) {
          return item.language == locale
        })[0];
      }
    },
    methods: {
      changeLocale(locale) {
        this.$store.dispatch('Localization/setLocale', locale);

        let loggedUser = this.$store.getters['Auth/loggedUser'];
        if (loggedUser.id !== undefined) {
          UserService.setLanguage(locale);
        }

      }
    }
  };
</script>
<style lang="scss">
  .language-dropdown {
    cursor: pointer;
    margin-left: -1rem;
  }
</style>